import { PointsRange } from '../constants/PointsRange';

export const getPointsRange = (points: number) => {
    if (points < 8) {
        return PointsRange.First;
    }
    if (points < 16) {
        return PointsRange.Second;
    }
    if (points < 20) {
        return PointsRange.Third;
    }
    return PointsRange.Fourth;
};
